<template>
  <!-- モーダルウインドウ -->
  <transition name="modal">
    <div v-if="isShow" @click.self="clickOutside&&hideModal()" :class="classObject" class="content_modal">
      <div class="c-modal__inner content_modal_inner">
        <div v-if="closeBtn || title" class="c-modal__head content_modal_head" :class="onlyCloseBtn ? 'onlyCloseBtn' : ''" >
          <!-- 閉じるボタン -->
          <div v-if="closeBtn" @click="hideModal()" class="content_closeBtn">
            <div class="content_closeBtn_btn"></div>
          </div>
          <div
            v-else-if="noCloseOnBackdrop"
            @click="$emit('close')"
            class="c-modal__btnClose"
          >
            <button style="background: #fff; cursor: pointer;">
              <Icon name="action_close" width="18" height="18" />
            </button>
          </div>

          <!-- タイトル -->
          <h3 v-if="title" class="c-modal__head__title">{{ title }}</h3>
          <!-- HTMLとして渡すタイトル -->
          <h3
            v-if="htmlTitle"
            v-html="htmlTitle"
            class="c-modal__head__title c-modal__head__title--textArignLeft"
          ></h3>

          <p v-if="licenser" class="c-modal__head__licenser">{{ licenser }}</p>
        </div>

        <div class="c-modal__content content_modal_content">
          <!-- <div tabindex="0" ref="modalStartFocus" @keydown.prevent.shift.tab="moveBottom"></div> -->
          <slot />
          <!-- <div tabindex="0" ref="modalEndFocus" @keydown.prevent.tab.exact="moveTop"></div> -->
        </div>
      </div>
      <!-- /.c-modal__inner -->
    </div>
    <!-- /.c-modal -->
  </transition>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    closeBtn: {
      type: Boolean,
      default: true
    },
    clickOutside: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    htmlTitle: {
      type: String,
      default: ""
    },
    licenser: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    widthSize: {
      type: String,
      default: ""
    },
    isHideValid: {
      type: Boolean,
      default: true
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    isShow: false,
    scrollTopTimer: false,
    scrollTopFlg: false,
    fromTop: null
  }),

  computed: {
    widthSizeClass() {
      if (!this.widthSize) return;
      return "c-modal--width" + this.widthSize;
    },
    classObject() {
      return ["c-modal", this.widthSizeClass];
    },
    /**
     * モーダル内のコンテンツが閉じるボタン「x」のみの場合
     * @return { Boolean }
     */
    onlyCloseBtn() {
      if (this.closeBtn && !this.title) return true
      return false
    }
  },

  mounted() {
    // 画面をリサイズした時にもモーダル用に高さを取得
    const onResize = _.debounce(this.setHeight, 200);
    window.addEventListener("resize", onResize);
    this.$once("hook:beforeDestroy", function() {
      window.removeEventListener("resize", onResize);
    });
    this.setHeight();
  },

  methods: {
    show() {
      if (this.isShow) return;
      this.isShow = true;
      // this.$modal.inert = true;
      this.fixScroll();
    },
    hideModal() {
      if (!this.isHideValid) return;
      this.hide();
    },
    hide() {
      if (!this.isShow) return;
      this.isShow = false;
      this.$emit("hide", "");
      // this.$modal.inert = false;
      this.fixReset();
    },
    fixReset() {
      document.body.style.top = "";
      document.body.style.position = "static";
      window.scrollTo({ top: parseInt(this.fromTop || "0") });
    },
    fixScroll() {
      // 表示時にスクロールを固定
      if (this.isShow) {
        this.fromTop = window.scrollY;
        document.body.style.width = "100%";
        document.body.style.top = `-${this.fromTop}px`;
        document.body.style.position = "fixed";
      }
    },
    // モーダルのSP用にアドレスバーを除いた画面の高さを取得
    setHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
  },

  beforeDestroy() {
    this.fixReset();
  }
};
</script>

<style lang="scss" scoped>
.modal-enter-active,
.modal-leave-active .modal-enter,
.modal-leave-to {
  transition: opacity ease 0.2s;
}

.modal-enter-active,
.modal-leave-active {
  opacity: 1;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}

.c-modal__head__licenser {
  margin-top: 1.125rem;
  text-align: right;
}

.content {
  &_modal {
    padding: 0 10px;
    align-items: center !important;
    &_inner {
      overflow: scroll;
      width: 100%;
      max-width: 1032px;
      border-radius: 8px;
    }
    &_head {
      border-radius: 8px 8px 0 0;
    }
    &_content {
      padding-bottom: 100px;
    }
  }
  &_closeBtn {
    position: absolute;
    top: -35px;
    right: -10px;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    transition-property: transform;
    transition-duration: 0.2s;
    cursor: pointer;
    font-size: 0;
    line-height: 1;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    &_btn {
      width: 100%;
      height: 100%;
      &::before, 
      &::after {
        content: "";
        display: block;
        width: 36px;
        height: 3px;
        border-radius: 10px;
        background-color: white;
        transform-origin: center;
      }
      &::before {
        transform: rotate(45deg) translate(1px, 2px);
      }
      &::after {
        transform: rotate(-45deg);
      }
    }
  }
}

// モーダル内コンテンツが閉じるボタンのみの場合
.onlyCloseBtn {
  padding-bottom: 52px;
}

@media only screen and (max-width: 639px) {
  .content {
    &_modal {
      &_inner {
        border-radius: 6px !important;
      }
      &_head {
        border-radius: 6px 6px 0 0;
      }
      &_content {
        padding: 0 20px 20px;
      }
    }
    &_closeBtn {
      top: -20px;
      right: 0;
      width: 14px;
      height: 14px;
      &_btn {
        &::before, 
        &::after {
          width: 16px;
          height: 2px;
          border-radius: 10px;
        }
        &::before {
          transform: rotate(45deg) translate(1px, 2px);
        }
        &::after {
          transform: rotate(-45deg);
        }
      }
    }
  }

  // モーダル内コンテンツが閉じるボタンのみの場合
  .onlyCloseBtn {
    padding: 20px 0 0;
  }
}
@import './style.scss';
</style>
